import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Zap',
      title: 'Instant Offers',
      description: 'Get multiple competitive offers within 24 hours. Our AI-powered valuation system ensures you get the best price for your vehicle.',
      features: ['AI-powered pricing', 'Multiple dealer offers', 'No obligation to sell']
    },
    {
      icon: 'Truck',
      title: 'Free Pickup',
      description: 'We come to you anywhere in the country. Free pickup, inspection, and paperwork handling at your preferred location.',
      features: ['Nationwide coverage', 'Flexible scheduling', 'Professional service']
    },
    {
      icon: 'Shield',
      title: 'Secure Payment',
      description: 'Get paid instantly via bank transfer, certified check, or cash. All transactions are secured and guaranteed.',
      features: ['Instant payment', 'Multiple payment options', 'Fraud protection']
    }
  ];

  return (
    <section id="benefits-section" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Why Choose iSell.car?
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            We've revolutionized car selling with technology, transparency, and trust. 
            Experience the fastest, safest way to sell your vehicle.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-border hover:border-blue-200 hover:shadow-lg transition-all duration-300"
            >
              {/* Icon */}
              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon name={benefit.icon} size={32} color="white" />
                </div>
              </div>

              {/* Content */}
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-foreground group-hover:text-blue-600 transition-colors">
                  {benefit.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
                
                {/* Feature List */}
                <ul className="space-y-2">
                  {benefit.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center space-x-2 text-sm text-muted-foreground">
                      <Icon name="Check" size={14} className="text-green-500 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-indigo-600/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center space-x-4 bg-gradient-to-r from-blue-50 to-indigo-50 px-8 py-4 rounded-2xl border border-blue-100">
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="Clock" size={16} className="text-blue-600" />
              <span>Average selling time: <span className="font-semibold text-foreground">3.2 hours</span></span>
            </div>
            <div className="w-px h-6 bg-border"></div>
            <div className="flex items-center space-x-2 text-sm text-muted-foreground">
              <Icon name="TrendingUp" size={16} className="text-green-600" />
              <span>Average price increase: <span className="font-semibold text-foreground">12% above market</span></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;